import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "src/components/common/ProtectedTenantRoute";
import LoginPage from "./LoginPage";
import RegisterPage from "./RegisterPage";
import ForgotPasswordPage from "./ForgotPasswordPage";
import ResetPasswordPage from "./ResetPasswordPage";
import PublicInvoicePage from "./invoices/PublicInvoicePage";
import PublicPurchaseInvoicePage from "./invoices/PublicPurchaseInvoicePage";
import { appRoutes } from "./routes.config";

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      {/* Publicly shareable invoice link — intentionally outside
          ProtectedRoute, no login required to view/download. */}
      <Route path="/invoices/:invoiceId" element={<PublicInvoicePage />} />
      <Route
        path="/purchase-invoices/:invoiceId"
        element={<PublicPurchaseInvoicePage />}
      />
      {appRoutes.map((r, idx) => (
        <Route
          key={idx}
          path={r.path}
          element={<ProtectedRoute>{r.element}</ProtectedRoute>}
        />
      ))}

      {/* Fallback redirect */}
      <Route path="/*" element={<Navigate to="/app/dashboard" replace />} />
    </Routes>
  );
};

export default AppRoutes;
